import { render, staticRenderFns } from "./DialogNewReturned.vue?vue&type=template&id=038c7de3&scoped=true"
import script from "./DialogNewReturned.vue?vue&type=script&lang=js"
export * from "./DialogNewReturned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c7de3",
  null
  
)

export default component.exports